/**
 * 패널 위치 상수
 */
const PanelPosition = {
  bottom: 'bottom',
  right: 'right',
} as const;

/**
 * 패널 DOM ID
 */
const SplitPanelId = 'split-panel';
const SplitPanelInnerId = 'split-panel-inner';

export { PanelPosition, SplitPanelId, SplitPanelInnerId };
